import * as Html from "../util/Html.ts";

export {init}
Html.registerWidget('widget/copytext',{init:init})

function init(obj){
  var 
    selector = obj.data('selector'),
    copiedText = obj.data('copiedtext'),
    htmlReset = obj.html();
  
  obj.css('transition','all 200ms')
  obj.on('click',function(){
    var 
      node = $(selector),
      input = document.createElement('input');
    
    input.type="text";
    input.value=node.text();
    document.body.appendChild(input)
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    obj.css('background-color','#8ec549');
    obj.html(copiedText);
    setTimeout(function(){
      obj.css('background-color','');
      obj.html(htmlReset);
    },1000)
  })
}